import { WhatsappLogo } from "@phosphor-icons/react";
import { WHATSAPP_QUOTE_URL } from "@/data/site";

const FloatingWhatsApp = () => {
  return (
    <a
      href={WHATSAPP_QUOTE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      className="fixed bottom-8 right-8 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:scale-110 transition-transform z-50 flex items-center justify-center whatsapp-float"
      aria-label="Conversar no WhatsApp"
    >
      <WhatsappLogo size={32} weight="fill" />
    </a>
  );
};

export default FloatingWhatsApp;
